<template>
  <div>
    <b-container fluid>
      <b-row v-if="collapseBtnLabel">
        <b-btn @click="showAudits"
               :class="tableCollapsed ? 'audits-button collapsed' : 'audits-button'"
               aria-controls="auditsTable"
               :aria-expanded="tableCollapsed ? 'true' : 'false'"
               variant="link">
          {{ collapseBtnLabel }}
        </b-btn>
      </b-row>
      <b-collapse class="mt-2" v-model="tableCollapsed" id="auditsTable">
        <b-table :items="audits"
                 :fields="tableFields"
                 :perPage="perPage">
        </b-table>

        <b-row>
          <b-col md="6" class="my-1">
            <b-pagination :total-rows="totalCount"
                          :per-page="perPage"
                          v-model="currentPage"
                          @change="loadAudits"
                          class="my-0" />
          </b-col>
        </b-row>
      </b-collapse>
    </b-container>
  </div>
</template>

<script>
import ContingentsProvider from '@/services/ContingentsProvider'
import Vue from 'vue'

export default {
  name: 'AuditsContainer',
  props: {
    auditableId: Number,
    collapseBtnLabel: String
  },
  data () {
    return {
      audits: [],
      tableCollapsed: !this.collapseBtnLabel,
      perPage: 20,
      currentPage: 1,
      totalCount: null,
      tableFields: [
        { key: 'username' },
        {
          key: 'timestamp',
          formatter: (value) => {
            const datetime = new Date(value)
            return datetime.toLocaleString('de-DE', Vue.datetime_format_options)
          }
        },
        {
          key: 'changes',
          class: 'audits-changes-col',
          formatter: (value) => { return JSON.stringify(value) }
        }
      ]
    }
  },
  methods: {
    showAudits () {
      this.tableCollapsed = !this.tableCollapsed
      if (this.tableCollapsed) {
        this.loadAudits(1)
      }
    },
    loadAudits (page) {
      this.currentPage = page

      ContingentsProvider
        .audits(this.auditableId, this.currentPage, this.perPage)
        .then((resp) => {
          this.audits = resp.body.audits
          this.totalCount = resp.body.total
        })
    }
  },
  beforeMount () {
    if (!this.tableCollapsed) { return }

    this.loadAudits(1)
  }
}
</script>

<style scoped>
  .audits-button {
    color: black;
    font-weight: bolder;
  }
</style>
